let s1 = ''
console.log("process.env.NODE_ENV",process.env.NODE_ENV)
switch (process.env.NODE_ENV) {
	case 'development':
        // 接口地址
		s1 = '/wxapp-api'
		break

	case 'production':
		s1 = ''
		break
}


export const apiPrefix = s1

export default {
    /* api 接口前缀 */
    prefix: apiPrefix,
    /* api 接口超时时间 */
    readTimeout: 60 * 1000 * 10,
    /* 安全令牌类型 */
    tokenType: 'admin',
    /* api 接口返回的错误码 */
    errno: {
        /* 需要安全令牌 */
        requireAccessToken: 1001,
        /* 不是有效的安全临牌 */
        invalidAccessToken: 1002,
        /* 安全令牌已失效 */
        accessTokenExpired: 1003,
        /* 数据完整性验证错误 */
        dataValidationError: 1006,
        /* 接口请求出错 */
        apiCallException: -1,
        /* 接口数据解析异常 */
        apiResultParseException: -2,
        /* token刷新失败 */
        tokenRefreshException: -3
    },


    'get.partner': {
        url: '/pc/partner'
    },
    'get.advertising': {
        url: '/pc/advertising'
    },
    'get.config': {
        url: '/pc/config'
    },
    'get.contacts': {
        url: '/pc/contacts'
    },
    'get.partner': {
        url: '/pc/partner'
    },
    'get.picture': {
        url: '/pc/picture'
    },
    'get.product': {
        url: '/pc/product'
    },
    'get.article': {
        url: '/pc/article'
    },
    
}



// WEBPACK FOOTER //
// ./src/config/api_config.js